import { Cart } from "@spartacus/cart/base/root";
import { Address, User } from '@spartacus/core';

export enum CustomPaymentTypeEnum {
  ACCOUNT_PAYMENT = 'BankAccount',
  CARD_PAYMENT = 'CreditCard',
  PAYPAL_PAYMENT = 'Paypal',
  SEQURA_PAYMENT_PP3 = 'pp3',
  SEQURA_PAYMENT_SP1 = 'sp1',
}

interface CustomAddress extends Address{
  billing?: boolean;
  documentIdentifier?: string;
  sameAsShippingAddress?: boolean;
  professional?: boolean;
  consumer?: boolean;
  visibleInAddressBook?: boolean;
}

export interface CustomCart extends Cart {
  customer?: User
  paymentAddress?: CustomAddress
}
